package com.wintermar.inspection.core.ui.component.badge.variant

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.component.TextBodyRegular
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.component.TextBodyTiny

@Composable
fun BadgeLabel(
    label: String,
    sizeType: BadgeSizeType,
    textColor: Color
) {
    when (sizeType) {
        BadgeSizeType.SMALL -> TextBodyTiny(
            text = label,
            color = { textColor },
            bold = true
        )

        BadgeSizeType.MEDIUM -> TextBodySmall(
            text = label,
            color = { textColor },
            bold = true
        )

        BadgeSizeType.LARGE -> TextBodyRegular(
            text = label,
            color = { textColor },
            bold = true
        )
    }
}
